import { defineComponent as _defineComponent } from 'vue';
import { STATES } from "./states";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StatesInfo',
    props: {
        excludeStates: { type: (Array), required: false, default: () => ["empty", "failed", "upload"] },
    },
    emits: ["set-filter"],
    setup(__props, { emit }) {
        const props = __props;
        const states = STATES;
        const helpText = {
            failed: "The job failed to run.",
            ok: "The dataset has no errors.",
        };
        if (props.excludeStates) {
            for (const state of props.excludeStates) {
                delete states[state];
            }
        }
        function dataState(state) {
            return state === "new_populated_state" ? "new" : state;
        }
        function onFilter(value) {
            emit("set-filter", `state`, value);
        }
        return { __sfc: true, props, emit, states, helpText, dataState, onFilter };
    }
});
